import {
    FETCH_MERGED_SUMMARY,
    FETCH_MERGED_SUMMARY_FETCHING,
    FETCH_MERGED_SUMMARY_SUCCESS,
    FETCH_MERGED_SUMMARY_FAIL,
    SAVE_MERGED_SUMMARY,
    SAVE_MERGED_SUMMARY_SUCCESS
} from 'actions/ActionTypes.js';

import DateParser from 'utils/date/DateParser';

const INITIAL_STATE = {
    summaries: [],
    isFetching: false,
    fetchFailed: false
};

// ======= Fetching Handlers =======
const fetchMergedSummaryFetching = (state) => {
    return {
        ...state,
        isFetching: true,
        fetchFailed: false
    };
};

const fetchMergedSummarySuccess = (state, action) => {
    return {
        summaries: {
            ...state.summaries,
            [action.displayName]: {
                ...state.summaries[action.displayName],
                [action.calendarDate]: action.mergedSummary
            }
        },
        isFetching: false,
        fetchFailed: false
    };
};

const fetchMergedSummaryFail = (state, action) => {
    return {
        summaries: {
            ...state.summaries,
            [action.displayName]: {
                ...state.summaries[action.displayName],
                [action.calendarDate]: {}
            }
        },
        isFetching: false,
        fetchFailed: true
    };
};

// ======= Updating Handlers =======
const saveMergedSummarySuccess = (state, action) => {
    return {
        summaries: {
            ...state.summaries,
            [action.mergedSummary.displayName]: {
                ...state.summaries[action.mergedSummary.displayName],
                [action.mergedSummary.calendarDate]: action.mergedSummary
            }
        }
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_MERGED_SUMMARY_FETCHING]: fetchMergedSummaryFetching,
    [FETCH_MERGED_SUMMARY_SUCCESS]: fetchMergedSummarySuccess,
    [FETCH_MERGED_SUMMARY_FAIL]: fetchMergedSummaryFail,
    [SAVE_MERGED_SUMMARY_SUCCESS]: saveMergedSummarySuccess
};

// ======= Default Action =======
export default function mergedSummary(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchMergedSummary(displayName, calendarDate, evictCache) {
    return {
        type: FETCH_MERGED_SUMMARY,
        displayName: displayName,
        calendarDate: calendarDate,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======
export const getMergedSummary = (state, displayName, calendarDate) => {
    return state.mergedSummary.summaries[displayName] ? state.mergedSummary.summaries[displayName][calendarDate] : null;
};

export const isMergedSummaryFetching = (state) => {
    return state.mergedSummary.isFetching;
};

export const didMergedSummaryFetchFail = (state) => {
    return state.mergedSummary.fetchFailed;
};

// Note, make sure to pass along displayName when saving back to the UDS
// > the API returns back null for displayName on GET but when set explicitly on a PUT it returns back the set displayName in the PUT response
export function saveMergedSummary(mergedSummary) {
    return {
        type: SAVE_MERGED_SUMMARY,
        payload: mergedSummary
    };
}

export const isTimeChange = (state, displayName, calendarDate) => {
    let mergedSummary = getMergedSummary(state, displayName, calendarDate);

    if (!mergedSummary || !mergedSummary.wellnessEndTimeGmt || !mergedSummary.wellnessStartTimeGmt) {
        return false;
    } else {
        let startTimeGMTMillis = DateParser.parseISOUTC(mergedSummary.wellnessStartTimeGmt).getTime();
        let startTimeLocalMillis = DateParser.parseISOUTC(mergedSummary.wellnessStartTimeLocal).getTime();
        let endTimeGMTMillis = DateParser.parseISOUTC(mergedSummary.wellnessEndTimeGmt).getTime();
        let endTimeLocalMillis = DateParser.parseISOUTC(mergedSummary.wellnessEndTimeLocal).getTime();

        let startOffset = startTimeLocalMillis - startTimeGMTMillis;
        let endOffset = endTimeLocalMillis - endTimeGMTMillis;

        if (startOffset === endOffset) {
            return false;
        } else {
            return {
                startOffset: startOffset / 3600000,
                endOffset: endOffset / 3600000
            };
        }
    }
};
